import React from 'react';

import AddIcon from '@atlaskit/icon/core/add';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalIconButtonTrigger } from '@atlassian/entry-points/modal-icon-button-trigger';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function ModalIconButtonTriggerExample(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<ModalIconButtonTrigger
					entryPoint={modalEntryPoint}
					modalTitle="Example Modal"
					loadingText="Loading example modal"
					icon={AddIcon}
					label="Add item"
					aria-haspopup="dialog"
				/>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
